import { BusinessAddress } from '@Pages/happyFlowPages/businessAddress/BusinessAddress';
import { beforeLoadGeneral } from '@Router/middleware';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { rootRoute } from './rootRoute';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { KnowYourBusinessPage, BusinessTypeSelectionPage, IndustryPage } from '..';
import { useBoundStore } from '@Store/useBoundStore';
import { getIndustryList } from '@Pages/happyFlowPages/industry/api/industry.api';
import { Spinner } from '@lili/lili-frontend-common';

import { GeneralSpinner } from '@Components/generalSpinner';

const getObData = useBoundStore.getState().onboardingSlice.getOnboardingData;

const KnowYourBusinessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.KNOW_YOUR_BUSINESS].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.KNOW_YOUR_BUSINESS,
      shouldUpdateServerNavStack: true,
      stepToReturn: RoutesMap.BUSINESS_TYPE_SELECTION,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <KnowYourBusinessPage />
    </Suspense>
  ),
});

const BusinessTypeSelectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.BUSINESS_TYPE_SELECTION].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      force: !getObData().editMode,
      page: RoutesMap.BUSINESS_TYPE_SELECTION,
      shouldUpdateServerNavStack: true,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <BusinessTypeSelectionPage />
    </Suspense>
  ),
});
const BusinessAddressRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.BUSINESS_ADDRESS].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.BUSINESS_ADDRESS,
      shouldUpdateServerNavStack: true,
      stepToReturn: RoutesMap.BUSINESS_TYPE_SELECTION,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <BusinessAddress />
    </Suspense>
  ),
});


const getIndustryListQueryData = {
  queryKey: ['getIndustryList'],
  queryFn: () => getIndustryList(),
};

const IndustryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.INDUSTRY].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.INDUSTRY,
      shouldUpdateServerNavStack: true,
      stepToReturn: RoutesMap.BUSINESS_TYPE_SELECTION,
    });
    return {
      getIndustryListQueryData,
    };
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(context.getIndustryListQueryData),
  component: function IndustryComponent() {
    const { data: industries } = useSuspenseQuery(getIndustryListQueryData);
    return (
      <Suspense fallback={<Spinner width='32px' height='32px' />}>
        <IndustryPage industries={industries} />
      </Suspense>
    );
  },
});

export const businessRoutes = [
  IndustryRoute,
  KnowYourBusinessRoute,
  BusinessTypeSelectionRoute,
  BusinessAddressRoute,

];
